import api from './api';

export interface Banner {
    _id: string;
    imageUrl: string;
    createdAt: string;
}

export const getBanners = async (): Promise<Banner[]> => {
    const response = await api.get('/banners');
    return response.data.banners;
};

export const uploadBanner = async (file: File): Promise<Banner> => {
    const formData = new FormData();
    formData.append('image', file);

    const response = await api.post('/banners/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.banner;
};

export const deleteBanner = async (id: string): Promise<void> => {
    await api.delete(`/banners/${id}`);
};
